"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AdvancedTable = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

var _Publish = _interopRequireDefault(require("@material-ui/icons/Publish"));

var _classnames = _interopRequireDefault(require("classnames"));

var _muiDatatables = _interopRequireDefault(require("mui-datatables"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../Button"));

var _ThemeHelper = require("../Utilities/ThemeHelper");

var _styles2 = require("./styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var defaultProps = {
  title: "",
  options: {
    responsive: "stacked",
    filterType: "dropdown",
    pagination: true,
    expandableRows: false,
    resizableColumns: false,
    selectableRows: "multiple",
    caseSensitive: false,
    serverSide: false,
    rowHover: true,
    fixedHeader: false,
    elevation: 4,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    filter: true,
    sortFilterList: true,
    sort: true,
    search: true,
    print: true,
    viewColumns: true,
    download: true,
    downloadOptions: {
      filename: "tableDownload.csv",
      separator: ","
    }
  },
  data: [],
  columns: [],
  compact: false,
  responsiveBreakpoint: "md"
};

var AdvancedTable = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AdvancedTable, _Component);

  var _super = _createSuper(AdvancedTable);

  function AdvancedTable() {
    var _this;

    (0, _classCallCheck2.default)(this, AdvancedTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "makeClasses", function () {
      var _this$props = _this.props,
          compact = _this$props.compact,
          classes = _this$props.classes;
      return {
        paper: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.largePaper, !compact), classes.paper),
        responsiveScrollFullHeight: classes.responsiveScrollFullHeight,
        responsiveScrollMaxHeight: classes.responsiveScrollMaxHeight,
        tableRoot: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.largeRoot, !compact), "prmbl-advancedTable-tableRoot"),
        caption: "prmbl-advancedTable-caption",
        liveAnnounce: "prmbl-advancedTable-liveAnnounce",
        responsiveStacked: classes.responsiveStacked
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "makeOptions", function () {
      var options = _this.props.options;
      var downloadOptions = "downloadOptions" in options ? options.downloadOptions : {};

      var newOptions = _objectSpread(_objectSpread(_objectSpread({}, defaultProps.options), options), {}, {
        downloadOptions: _objectSpread(_objectSpread({}, defaultProps.options.downloadOptions), downloadOptions),
        customToolbar: _this.generateCustomToolbar
      });

      return newOptions;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "generateCustomToolbar", function () {
      var _this$props2 = _this.props,
          options = _this$props2.options,
          classes = _this$props2.classes;
      var onImport = "onImport" in options ? options.onImport : undefined;
      var customToolbar = "customToolbar" in options ? options.customToolbar : undefined;

      var renderToolBar = function renderToolBar(toolbar) {
        return typeof toolbar === "function" ? toolbar() : toolbar;
      };

      if (onImport) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
          type: "icon",
          onClick: onImport,
          className: (0, _classnames.default)("prmbl-advancedTable-importButton", classes.button),
          title: "Import"
        }, /*#__PURE__*/_react.default.createElement(_Publish.default, null)), renderToolBar(customToolbar));
      } else {
        return renderToolBar(customToolbar);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "makeStyleOverrides", function () {
      var _toolbar;

      var _this$props3 = _this.props,
          theme = _this$props3.theme,
          compact = _this$props3.compact;
      var tableStyles = (0, _styles2.styles)(theme);

      var options = _this.makeOptions();

      return {
        MUIDataTableBodyCell: {
          root: !compact && tableStyles.largeCell,
          cellStacked: tableStyles.cellStacked,
          responsiveStacked: tableStyles.responsiveStacked
        },
        MUIDataTableBodyRow: {
          root: _objectSpread(_objectSpread({}, !compact && tableStyles.largeRow), "onRowClick" in options && typeof options.onRowClick === "function" && tableStyles.clickable),
          responsiveStacked: _objectSpread({}, tableStyles.bodyRowResponsiveStacked)
        },
        MUIDataTableHeadCell: {
          root: !compact && tableStyles.largeHeaderCell,
          fixedHeader: !compact && tableStyles.largeHeaderCellFixed,
          sortAction: tableStyles.sortAction
        },
        MUIDataTableHeadRow: {
          root: !compact && tableStyles.largeHeaderRow
        },
        MUIDataTableSelectCell: {
          root: !compact && tableStyles.largeSelectCellTransparent,
          headerCell: !compact && options.fixedHeader || !("fixedHeader" in options) ? tableStyles.largeSelectCell : tableStyles.largeSelectCellTransparent
        },
        MUIDataTableToolbar: {
          root: tableStyles.toolbar,
          filterPaper: tableStyles.filterPaper
        },
        MUIDataTableToolbarSelect: {
          root: tableStyles.toolbarSelectRoot,
          title: tableStyles.toolbarSelectTitle,
          iconButton: tableStyles.toolbarSelectIconButton
        },
        MUIDataTableFilter: {
          root: tableStyles.filterRoot,
          gridListTile: tableStyles.gridListTile
        },
        MuiGridList: {
          root: tableStyles.gridListRoot
        },
        MuiGridListTile: {
          root: tableStyles.gridListTileRoot
        },
        MuiTableCell: {
          paddingCheckbox: tableStyles.paddingCheckbox,
          root: tableStyles.tableCellRoot
        },
        MuiTablePagination: {
          toolbar: (_toolbar = {}, (0, _defineProperty2.default)(_toolbar, theme.breakpoints.down("sm"), {
            justifyContent: "center",
            flexWrap: "wrap"
          }), (0, _defineProperty2.default)(_toolbar, "actions", (0, _defineProperty2.default)({}, theme.breakpoints.down("sm"), {
            marginLeft: 0
          })), _toolbar)
        }
      };
    });
    return _this;
  }

  (0, _createClass2.default)(AdvancedTable, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          theme = _this$props4.theme,
          classes = _this$props4.classes,
          className = _this$props4.className,
          responsiveBreakpoint = _this$props4.responsiveBreakpoint,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props4, ["theme", "classes", "className", "responsiveBreakpoint"]); // Override the responsive breakpoint, see https://github.com/gregnb/mui-datatables/issues/131#issuecomment-497135092

      var renderedTheme = _objectSpread({}, theme);

      renderedTheme.breakpoints.values.md = theme.breakpoints.values[responsiveBreakpoint];
      return /*#__PURE__*/_react.default.createElement(_ThemeHelper.StyleWithOverrides, {
        theme: renderedTheme,
        overrides: this.makeStyleOverrides()
      }, /*#__PURE__*/_react.default.createElement(_muiDatatables.default, (0, _extends2.default)({
        className: (0, _classnames.default)("prmbl-advancedTable", className),
        classes: this.makeClasses()
      }, otherProps, {
        options: this.makeOptions()
      })));
    }
  }]);
  return AdvancedTable;
}(_react.Component); // export default withStyles(styles)(AdvancedTable);


exports.AdvancedTable = AdvancedTable;
(0, _defineProperty2.default)(AdvancedTable, "propTypes", {
  /** Title used to caption table */
  title: _propTypes.default.string.isRequired,

  /** Data used to describe table. Must be an array containing objects. (Arrays containing just strings or numbers also supported) */
  data: _propTypes.default.array.isRequired,

  /** Columns used to describe table. Must be either an array of simple strings or objects describing a column */
  columns: _propTypes.default.PropTypes.arrayOf(_propTypes.default.oneOfType([
  /**  */
  _propTypes.default.string, _propTypes.default.shape({
    /** Column Header Name override */
    label: _propTypes.default.string,

    /** Name of column */
    name: _propTypes.default.string.isRequired,

    /** Options for customizing column */
    options: _propTypes.default.shape({
      /** Display column in table. */
      display: _propTypes.default.oneOf([true, "true", false, "false", "excluded"]),

      /** This denotes whether the column has data or not (for use with intentionally empty columns) */
      empty: _propTypes.default.bool,

      /** Display column in filter list */
      filter: _propTypes.default.bool,

      /** Enable/disable sorting on column */
      sort: _propTypes.default.bool,

      /** Display column when printing */
      print: _propTypes.default.bool,

      /** Exclude/include column from search results */
      searchable: _propTypes.default.bool,

      /** Display column in CSV download file */
      download: _propTypes.default.bool,

      /**  */
      viewColumns: _propTypes.default.bool,

      /** Filter value list [Example](https://github.com/gregnb/mui-datatables/blob/master/examples/column-filters/index.js) */
      filterList: _propTypes.default.array,

      /** Filter options [Example](https://github.com/gregnb/mui-datatables/blob/master/examples/column-filters/index.js) */
      filterOptions: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object]),

      /** Function that returns a string or React component. Used as display for column header. `function(value, tableMeta, updateValue) => string` */
      customHeadRender: _propTypes.default.func,

      /** Function that returns a string or React component. Used as display data within all table cells of a given column. `function(value, tableMeta, updateValue) => string| React Component` [Example](https://github.com/gregnb/mui-datatables/blob/master/examples/component/index.js) */
      customBodyRender: _propTypes.default.func,

      /** If set, an import button will show on the table that will fire this callback when clicked */
      onImport: _propTypes.default.func
    })
  })])).isRequired,

  /** Options used to describe table */
  options: _propTypes.default.shape({
    /** Enable/disable responsive table views. */
    responsive: _propTypes.default.oneOf(["stacked", "scrollFullHeight", "scrollMaxHeight"]),

    /** Choice of filtering view */
    filterType: _propTypes.default.oneOf(["dropdown", "checkbox", "multiselect", "textField"]),

    /** User provided labels to localize text */
    textLabels: _propTypes.default.object,

    /** Enable/disable pagination */
    pagination: _propTypes.default.bool,

    /** Enable/disable expandable rows */
    expandableRows: _propTypes.default.bool,

    /** Render expandable row. `function(rowData, rowMeta) => React Component` */
    renderExpandableRow: _propTypes.default.func,

    /** Render a custom toolbar */
    customToolbar: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),

    /** Render a custom selected rows toolbar. `function(selectedRows, displayData, setSelectedRows) => void` */
    customToolbarSelect: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),

    /** Render a custom table footer. `function(count, page, rowsPerPage, changeRowsPerPage, changePage) => string| React Component` */
    customFooter: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),

    /** Callback function that triggers when a row is clicked. `function(rowData: string[], rowMeta: { dataIndex: number, rowIndex: number }) => void` */
    onRowClick: _propTypes.default.func,

    /** Enable/disable resizable columns */
    resizableColumns: _propTypes.default.bool,

    /** Numbers of rows that can be selected. Options are `multiple`, `single`, `none`. */
    selectableRows: _propTypes.default.oneOf(["none", "single", "multiple"]),

    /** Enable/disable selection on certain rows with custom function. Returns `true` if not provided. `function(dataIndex) => bool` */
    isRowSelectable: _propTypes.default.func,

    /** Callback function that triggers when table state has changed. `function(action: string, tableState: object) => void` */
    onTableChange: _propTypes.default.func,

    /** Enable/disable case sensitivity for search */
    caseSensitive: _propTypes.default.bool,

    /** Enable/disable hover style over rows */
    rowHover: _propTypes.default.bool,

    /** Enable/disable fixed header columns */
    fixedHeader: _propTypes.default.bool,

    /** User provided starting page for pagination */
    page: _propTypes.default.number,

    /** User provided override for total number of rows */
    count: _propTypes.default.number,

    /** User provided selected rows */
    rowsSelected: _propTypes.default.array,

    /** Number of rows allowed per page */
    rowsPerPage: _propTypes.default.number,

    /** Options to provide in pagination for number of rows a user can select */
    rowsPerPageOptions: _propTypes.default.array,

    /** Show/hide filter icon from toolbar */
    filter: _propTypes.default.bool,

    /** Enable/disable sort on all columns */
    sort: _propTypes.default.bool,

    /** Override default sorting with custom function. `function(data: array, colIndex: number, order: string) => array` */
    customSort: _propTypes.default.func,

    /** Override default search with custom function. `customSearch(searchQuery: string, currentRow: array, columns: array) => boolean` */
    customSearch: _propTypes.default.func,

    /** Show/hide search icon from toolbar */
    search: _propTypes.default.bool,

    /** Show/hide print	icon from toolbar */
    print: _propTypes.default.bool,

    /** Show/hide viewColumns icon from toolbar */
    viewColumns: _propTypes.default.bool,

    /** Show/hide download icon from toolbar */
    download: _propTypes.default.bool,

    /** Options to change the output of the CSV file. */
    downloadOptions: _propTypes.default.shape({
      filename: _propTypes.default.string,
      separator: _propTypes.default.string
    }),

    /** A callback function that triggers when the user downloads the CSV file. In the callback, you can control what is written to the CSV file.
     * `function(buildHead: (columns) => string, buildBody: (data) => string, columns, data) => string` */
    onDownload: _propTypes.default.func,

    /** A callback function that triggers when the users clicks the import button. */
    onImport: _propTypes.default.func
  }),
  // Custom Props:

  /** Pass and use className to style MUIDataTable as desired */
  className: _propTypes.default.string,

  /** If `false`, the table will render with more padding in each row and more space between rows. */
  compact: _propTypes.default.bool,

  /** Adjust the width at which the table will break to the responsive view */
  responsiveBreakpoint: _propTypes.default.oneOf(["xs", "sm", "md", "lg"]),

  /**
   * @ignore
   *
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   *
   * Auto-populated by material-ui withTheme()
   */
  theme: _propTypes.default.object.isRequired
});
(0, _defineProperty2.default)(AdvancedTable, "defaultProps", defaultProps);

var _default = (0, _styles.withStyles)(_styles2.styles)((0, _styles.withTheme)(AdvancedTable));

exports.default = _default;